import get from 'lodash/get';
import * as tagPromoterChannelFcWorksActions from '../../action_creators/tag/tag_promoter_channel_fc_works';
import TagPromoterChannelFcWorksModel from '../../../models/tag/tag_promoter_channel_fc_works';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(
      tagPromoterChannelFcWorksActions.tagPromoterChannelFcWorksLoading(
        {},
        store
      )
    );
    return TagPromoterChannelFcWorksModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        dispatch(
          tagPromoterChannelFcWorksActions.tagPromoterChannelFcWorksLoaded(
            resp.data,
            store
          )
        );
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (params.tag !== 'living-smarter') {
          if (status === 404) {
            dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          } else {
            dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
            log.error(
              err,
              `Error in tag featured feed actions, message: ${err.message}`
            );
          }
        }
        dispatch(
          tagPromoterChannelFcWorksActions.tagPromoterChannelFcWorksError(
            err,
            store
          )
        );
      });
  };
}
